// (c) 2026 Owl Consultations. All rights reserved.
// Proprietary and confidential — licensed use only. Unauthorized use,
// copying, or distribution is prohibited and may be prosecuted.

import { Link } from 'react-router-dom'

// Global footer — appears on every in-app page via AppShell. Provides the
// required legal links (Privacy, Terms, Data Rights) on each page.
export default function AppFooter() {
  const year = new Date().getFullYear()
  const linkStyle: React.CSSProperties = { color: 'var(--color-text-muted)', textDecoration: 'none' }
  return (
    <footer
      style={{
        borderTop: '1px solid var(--color-border)',
        padding: '14px 24px',
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 8,
        fontSize: 12,
        color: 'var(--color-text-muted)',
      }}
    >
      <div style={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        <span>© {year} Owl Consultations · All rights reserved</span>
        <span>
          Proprietary licensed software — confidential. Unauthorized access, use, copying, or
          distribution is prohibited and may result in civil liability and criminal prosecution.
        </span>
      </div>
      <nav style={{ display: 'flex', gap: 14 }}>
        <Link to="/legal/privacy" style={linkStyle}>Privacy Policy</Link>
        <Link to="/legal/terms" style={linkStyle}>Terms of Use</Link>
        <Link to="/legal/data-rights" style={linkStyle}>Your Data Rights</Link>
        <Link to="/legal/accessibility" style={linkStyle}>Accessibility</Link>
      </nav>
    </footer>
  )
}
